import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environment';
import {catchError} from 'rxjs/operators';
import {parseResponse} from 'src/app/utils/parse-response.operator';
import {z} from 'zod';

@Injectable({
  providedIn: 'root',
})
export class GeoService {
  constructor(private http: HttpClient) {}

  /**
   * Get the city name by it's zip code
   * @param zipCode The zip code to search for
   */
  getCityByZipCode(zipCode: string): Observable<string> {
    return this.http
      .get(`${environment.endpoints.getCityForPostalCode}/${zipCode}`, {responseType: 'text'})
      .pipe(catchError(err => of('')));
  }

  /**
   * Find possible streets by the city's zip code and
   * a fraction of the actual street name
   * @param zipCode The zip code to search for
   * @param fraction The fraction of the actual street name to search for
   */
  getStreets(term: string, zipcode: string, city: string): Observable<string[]> {
    return this.http
      .get<string[]>(`${environment.endpoints.getStreetsForPostalCodeAndCity}/${zipcode}/${city}?term=${term}`)
      .pipe(parseResponse(z.array(z.string())));
  }
}
